<div class="container-fluid">
  <div class="card mt-3">
    <div class="card-header bg-light text-center">
      <div class="row">
        <div class="col-md-12">



          <div class="page-title-box">
            <div class="page-title-right" style="margin-top: 0px;">
              <a href="#/panel-admin" class="btn btn-primary">
                  Volver
              </a>
            </div>
            <h3 style="color: #016E97;">Reprogramación</h3>
          </div>


        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="col-12">
        <ng-select
        [items]="ocupaciones_accion"
        bindLabel="nombre"
        bindValue="id_accion_formativa_oc"
        (change)="buscar($event)"
        (clear)="cerrar()"
        notFoundText="No se encontraron resultados"
        typeToSearchText="Escribe para buscar"
        loadingText="Cargando..."
        selectPlaceholder = 'Selecciona una opción'
        ></ng-select>
      </div>
    </div>
  </div>
  <!--MODULO DE PROGRAMACION DOCENTE-->
  <div class="card mt-3" *ngIf="isActualiza">
    <div class="card-header text-center">
      <div class="row">
        <div class="col-md-4">
          <h5 class="text-dark">Código de O.C</h5>
          <label class="form-label">{{datos_ocupacion.codigo_of}}</label>
        </div>
        <div class="col-md-4">
          <h5 class="text-dark">Pre Impreso</h5>
          <label class="form-label">{{datos_ocupacion.pre_impreso}}</label>
        </div>
        <div class="col-md-4">
          <h5 class="text-dark">Horas</h5>
          <label class="form-label">{{datos_ocupacion.horas}}</label>
        </div>
      </div>
    </div>
    <div class="card-body">
      <form [formGroup]="formularioProgramacion" id="formularioProgramacion">
        <div class="row mt-4 mb-4">
          <div class="col-md-12 text-center">
            <h4>Lista de Perfiles</h4>
          </div>
        </div>
        <div class="accordion accordion-flush" id="acc_perfil" formArrayName="datosUC">
          <div *ngFor="let ppl of datos_perfiles; let i = index" class="accordion-item" [formGroupName]="i">
            <div class="accordion-item">
              <h2 class="accordion-header text-center" id="head{{ppl.key}}">
                <button class="accordion-button {{ppl.key != '180' ? 'collapsed' : ''}} {{ppl.key == '180' ? 'text-light' : ''}}"
                  [ngClass]="ppl.key == '180' ? 'color-primary' : 'bg-light'"
                  type="button"
                  attr.data-bs-toggle="{{!valida ? 'collapse' : ''}}"
                  attr.data-bs-target="#{{ppl.key}}"
                  attr.aria-expanded="{{ppl.key == '180' ? true : false}}"
                  attr.aria-controls="{{ppl.key}}" (click)="ppl.key != '180' ? mensaje_validador() : '' ">
                  ({{ppl.value[0].codigo_of_ppl}}) - {{ppl.value[0].nombre_perfil}} - (HORAS: {{ppl.value[0].horas}})
                </button>
              </h2>
              <div id="{{ppl.key}}" class="accordion-collapse collapse {{ppl.key == '180' ? 'show' : ''}} container-fluid" attr.aria-labelledby="head{{ppl.key}}" data-bs-parent="#acc_perfil">
                <div class="row g-3" *ngIf="ppl.key == '180'" >
                  <div class="col-md-12">
                    <h5 class="mt-3 mb-3 text-danger text-center">
                      Debe llenar de manera obligatoria el ciclo formativo Inicial
                    </h5>
                  </div>
                </div>
                <div formArrayName="unidadesCurriculares">
                  <div *ngFor="let uc of ppl.value; let j = index" [formGroupName]="j">
                    <div class="row g-3">
                      <div class="col-md-12">
                        <h6 class="mt-3 mb-3 text-center">
                          <span>{{j+1}}</span> - {{uc.nombre_oferta}}
                          <span style="color: #005676;">CODIGO OF:</span> {{uc.codigo_of_uc}}
                          <span style="color: #005676;">HORAS:</span> {{uc.horas_uc}}
                        </h6>
                      </div>
                    </div>
                    <ng-content *ngIf="!uc.esDuplicado">
                      <div class="row g-3">
                        <div class="col-md-1 text-center">
                          <label for="inputPassword4" class="form-label">Cupo</label>
                          <select class="form-select" id="cupo" name="cupo" formControlName="cupo">
                            <option *ngFor="let cp of listCupo;" [value]="cp.id">{{cp.id}}</option>
                        </select>
                        </div>
                        <div class="col-md-2 text-center">
                          <label for="inputPassword4" class="form-label">Turno</label>
                          <select class="form-select" id="id_turno" name="id_turno" formControlName="id_turno">
                            <option *ngFor="let tr of turno;" [value]="tr.id_turno">{{tr.nombre}}</option>
                          </select>
                        </div>
                        <div class="col-md-3 text-center">
                          <label for="inputAddress" class="form-label">Fecha Inicio</label>
                          <div class="input-group">
                            <input class="form-control" placeholder="Fecha Inicio" [readOnly]="true" ngbDatepicker #inicio="ngbDatepicker" formControlName="fecha_inicio">
                            <button class="btn btn-outline-secondary bi bi-calendar3 calendar" (click)="inicio.toggle()" type="button"></button>
                          </div>
                        </div>
                        <div class="col-md-3 text-center">
                          <label for="inputAddress" class="form-label">Fecha Culminación</label>
                          <div class="input-group">
                            <input class="form-control" placeholder="Fecha Culminación" [readOnly]="true" #fin="ngbDatepicker" ngbDatepicker formControlName="fecha_culminacion">
                            <button class="btn btn-outline-secondary bi bi-calendar3 calendar" (click)="fin.toggle()" type="button"></button>
                          </div>
                        </div>
                        <div class="col-md-3 text-center">
                          <label for="inputPassword4" class="form-label">Tipo Formador</label>
                          <select class="form-select" id="id_tipo_formador" name="id_tipo_formador" formControlName="id_tipo_formador" (change)="getFormador(i,j)">
                            <option value="">--Seleccione--</option>
                            <option *ngFor="let tp of tipo_formador;" [value]="tp.id_tipo_formador">{{tp.nombre}}</option>
                          </select>
                        </div>
                        <div class="col-12 text-center">
                          <label for="inputPassword4" class="form-label">Formador</label>

                          <ng-content *ngIf="listarUnidadFormador[i][j] == undefined">
                            <select class="form-select" id="id_formador" name="id_formador" formControlName="id_formador" (change)="verificador()">
                              <option value="" selected>--Seleccione--</option>
                              <option *ngIf="uc.nombre_facilitador != 0" [value]="uc.id_facilitador" [title]="uc.nombre_facilitador" selected>{{uc.nombre_facilitador}}</option>
                            </select>
                          </ng-content>

                          <ng-content *ngIf="listarUnidadFormador[i][j] != undefined">
                            <select class="form-select" id="id_formador" name="id_formador" formControlName="id_formador" (change)="verificador()">
                              <option value="" selected>--Seleccione--</option>
                              <option *ngFor="let fr of listarUnidadFormador[i][j];" [value]="fr.id_institucional">{{fr.nombre}}</option>
                            </select>
                          </ng-content>

                        </div>
                      </div>
                    </ng-content>
                    <hr style="border: 1px solid #005676; opacity: 0.5" class="mt-4 mb-4">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4" *ngIf="datos_perfiles.length > 0">
          <a style="cursor: pointer;" class="btn btn-lg btn-primary" (click)="cargar()">Aceptar</a>
        </div>
      </form>
    </div>
  </div>
</div>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>


<div style="margin-bottom: 300px;"></div>
